import { Box, InputAdornment, TextField, Typography, useTheme, Divider } from '@mui/material';
import { SearchFillIcon } from 'src/assets/icons/SearchFillIcon';

type Props = {
  handleSearch: (value: string) => void;
  searchTerm: string;
};

export const SidebarHeader = ({ handleSearch, searchTerm }: Props) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        padding: '20px',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      <Typography fontWeight={700}>Components</Typography>
      <TextField
        onChange={(event) => handleSearch(event.target.value)}
        value={searchTerm}
        name="search"
        fullWidth
        placeholder="Search components..."
        inputProps={{ style: { padding: '10px' }, 'data-sm': 'search-components-input' }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchFillIcon fill={theme.palette.text.disabled} />
            </InputAdornment>
          ),
        }}
      />
      <Divider />
    </Box>
  );
};
